import common from "../../../utils/common";
import c from "../../../utils/constants";

class userExternalAccountsController {
  constructor() {
    "ngInject"
    
  }
  
  $onInit() {
    
    this.gridOptions = {
      dataSource: this.externalAccounts,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No External Accounts."
      },
      columns: [
        { field: "name", title: "Name", filterable: false, width: "6rem" },
        { field: "status", title: "Status", filterable: false, width: "4rem", template: (dataItem) => `${this._getAccountType(dataItem.accountType)}` },
        { field: "email", title: "Email", filterable: false, width: "6rem" },
        { field: "creationDate", title: "Creation Date", filterable: false, width: "4rem", template: `#= kendo.toString(new Date(creationDate), 'dd/MM/yyyy')#` },
      ]
    }
  }
  
  _getAccountType(type) {
    switch(type) {
      case c.externalAccountType.FACEBOOK:
        return "Facebook";
      case c.externalAccountType.LINKEDIN:
        return "LinkedIn";
    }
  }
  
}

export default userExternalAccountsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-external-accounts/user-external-accounts.controller.js
 **/